import { Codeowners } from '../consts/codeowners';

import { captureException } from './exception';

interface Mime {
  mime: string;
  pattern: (number | undefined)[];
}

const imageMimes: Mime[] = [
  {
    mime: 'image/heif',
    pattern: [undefined, undefined, undefined, undefined, 0x66, 0x74, 0x79, 0x70, 0x6d, 0x69, 0x66, 0x31],
  },
  {
    mime: 'image/heif',
    pattern: [undefined, undefined, undefined, undefined, 0x66, 0x74, 0x79, 0x70, 0x68, 0x65, 0x69, 0x63],
  },
  {
    mime: 'image/png',
    pattern: [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a],
  },
  {
    mime: 'image/jpeg',
    pattern: [0xff, 0xd8, 0xff, 0xdb],
  },
  {
    mime: 'image/jpeg',
    pattern: [0xff, 0xd8, 0xff, 0xe1, undefined, undefined, 0x45, 0x78, 0x69, 0x66, 0x00, 0x00],
  },
  {
    mime: 'image/jpeg',
    pattern: [0xff, 0xd8, 0xff, 0xe0, undefined, undefined, 0x4a, 0x46, 0x49, 0x46, 0x00, 0x01],
  },
  {
    mime: 'image/webp',
    pattern: [0x52, 0x49, 0x46, 0x46, undefined, undefined, undefined, undefined, 0x57, 0x45, 0x42, 0x50],
  },
];

function isMime(bytes: Uint8Array, mime: Mime): boolean {
  return mime.pattern.every((p, i) => !p || bytes[i] === p);
}

export const getMimeType = (file: File): Promise<Mime | undefined> => {
  try {
    const fileReader = new FileReader();
    const numBytesNeeded = Math.max(...imageMimes.map((m) => m.pattern.length));
    const blob = file.slice(0, numBytesNeeded); // Read the needed bytes of the file

    return new Promise((resolve) => {
      fileReader.onloadend = (e) => {
        if (!e || !fileReader.result) return;

        const bytes = new Uint8Array(fileReader.result as ArrayBuffer);
        const mimeType = imageMimes.find((mime) => isMime(bytes, mime));
        resolve(mimeType);
      };

      fileReader.readAsArrayBuffer(blob);
    });
  } catch (error) {
    captureException(error, Codeowners.CUSTOMER_INTAKE);
    return Promise.resolve(undefined);
  }
};
